import { render, staticRenderFns } from "./media_image.vue?vue&type=template&id=9d673344&scoped=true&lang=pug"
import script from "./media_image.vue?vue&type=script&lang=js"
export * from "./media_image.vue?vue&type=script&lang=js"
import style0 from "./media_image.vue?vue&type=style&index=0&lang=scss"
import style1 from "./media_image.vue?vue&type=style&index=1&id=9d673344&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d673344",
  null
  
)

export default component.exports